import { TRAVEL_TYPE_OWN_ARRIVAL, TRAVEL_TYPE_PACKAGE_TOUR } from '../../../components/models.js';
export const slicePrefix = slice => `uiState/searchForm/${slice}`;
export const searchFormScopedAction = (action, additionalMeta) => ({
  type: slicePrefix(action.type),
  payload: action.payload,
  meta: {
    ...action.meta,
    ...additionalMeta
  }
});
export const mapBooleanToEvent = value => value ? '1' : '0';
export const mapTravelType = travelType => {
  switch (travelType) {
    case TRAVEL_TYPE_PACKAGE_TOUR:
      return 'pt';
    case TRAVEL_TYPE_OWN_ARRIVAL:
      return 'oa';
    default:
      return '';
  }
};